/**
 * PORT: the app's privacy switches the game shows in the account dialog (src/client/platform/integrations.ts creates
 * them; absent on the web page and in a build without Firebase): diagnostics (Firebase Crashlytics and Analytics) and
 * push notifications (Firebase Cloud Messaging). Both are off until the player turns them on.
 */
import * as T from './auth-texts';

export interface IntegrationsPort {
  telemetry: { available(): boolean; enabled(): boolean; setEnabled(on: boolean): Promise<void> } | null;
  push: { available(): boolean; enabled(): boolean; setEnabled(on: boolean): Promise<'on' | 'off' | 'denied' | 'unavailable'> } | null;
}

/**
 * The account dialog's switches of the port (each a small button naming its state; a press toggles it, and the game
 * says what happened): none without the port or where a switch is unavailable.
 */
export function integrationExtras(port: IntegrationsPort | null | undefined, notice: (text: string) => void): Array<{ name: string; label: string; run(): void }> {
  const out: Array<{ name: string; label: string; run(): void }> = [];
  const t = port?.telemetry;
  if (t && t.available()) {
    const on = t.enabled();
    out.push({ name: 'telemetry_toggle', label: on ? T.MSG_DIAG_ON : T.MSG_DIAG_OFF, run: () => void t.setEnabled(!on).then(() => notice(on ? T.MSG_DIAG_NOTE_OFF : T.MSG_DIAG_NOTE_ON)) });
  }
  const p = port?.push;
  if (p && p.available()) {
    const on = p.enabled();
    out.push({
      name: 'push_toggle',
      label: on ? T.MSG_PUSH_ON : T.MSG_PUSH_OFF,
      run: () =>
        void p.setEnabled(!on).then((r) => notice(r === 'on' ? T.MSG_PUSH_NOTE_ON : r === 'off' ? T.MSG_PUSH_NOTE_OFF : r === 'denied' ? T.MSG_PUSH_DENIED : T.MSG_PUSH_FAILED)),
    });
  }
  return out;
}
